/**
 * ToolsHelpModal.js - Available Tools Help Popup
 * Displays the list of tools the current user has access to, with descriptions
 * and usage examples.
 */

import React, { useCallback } from 'react';

function ToolsHelpModal({ isOpen, onClose, tools = [] }) {
  const handleOverlayClick = useCallback(
    (e) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    },
    [onClose]
  );

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    },
    [onClose]
  );

  if (!isOpen) return null;

  return (
    <div
      className="tools-help-modal-overlay"
      onClick={handleOverlayClick}
      onKeyDown={handleKeyDown}
      role="dialog"
      aria-modal="true"
      aria-label="Available Tools"
    >
      <div className="tools-help-modal">
        <div className="tools-help-modal-header">
          <span className="tools-help-modal-title">Available Tools</span>
          <button
            type="button"
            className="tools-help-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="tools-help-modal-content">
          {tools.length === 0 ? (
            <p className="tools-help-empty">No tools available.</p>
          ) : (
            tools.map((tool) => (
              <div key={tool.tool_id} className="tools-help-item">
                <h3 className="tools-help-item-name">{tool.name}</h3>
                <p className="tools-help-item-description">{tool.description}</p>
                {tool.examples && tool.examples.length > 0 && (
                  <div className="tools-help-item-examples">
                    <span className="tools-help-examples-label">Try asking:</span>
                    <ul>
                      {tool.examples.map((example, i) => (
                        <li key={i}>"{example}"</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default ToolsHelpModal;
